import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LoanComputationService } from '../my-home-page/service/loan-computation.service';
import { MyHomeService } from '../my-home-page/service/my-home.service';
import { MyHomeState } from '../my-home-page/state/my-home.state';
import { SaveEquityAnalysisDialogboxComponent } from '../save-equity-analysis-dialogbox/save-equity-analysis-dialogbox.component';


@Component({
  selector: 'app-equity-analysis',
  templateUrl: './equity-analysis.component.html',
  styleUrls: ['./equity-analysis.component.scss']
})

export class EquityAnalysisComponent implements OnInit {
  onDestroyNotifier$ = new Subject<void>();
  propertyData: any;
  listingImageBaseUrl = environment.listingImageBaseUrl;
  propmixValue: any;
  currentValue: any;
  purchaseValue: any;
  appreciateRatio: number;
  netEquity: number;
  loanBalance: any;
  mortgageArray: any[];
  formatMortgage: any;
  PMXPropertyId: any;
  listingData: any;
  customPurchasePrice: any;
  finalMortgaeList: any;
  homeValue: any;
  source: any;
  equityId: any;
  existingEquityName: any;
  button: string;
  customMonthlyCostData: any;
  constructor(
    private myHomeService: MyHomeService,
    public myHomeState: MyHomeState,
    private loanService: LoanComputationService,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,

  ) {


  }

  ngOnInit(): void {

    this.resetData();
    this.activatedRoute.queryParams.subscribe((params) => {
      this.PMXPropertyId = params['property-id'];
      this.source = params['action'];
      this.equityId = params['equity-id'];
      this.button = this.source == 'edit' ? 'Update Equity' : 'Save Equity';

      if (this.PMXPropertyId && !params['action']) {
        this.equityAnalysis({ PMXPropertyId: this.PMXPropertyId });
        this.myHomeService.getPropertyDetails({
          pmxPropertyId: this.PMXPropertyId,
          type: ['basic', 'avm', 'listing'],
        });
      }

      if (this.PMXPropertyId && params['action']) {
        this.myHomeService.getPropertyDetails({
          pmxPropertyId: this.PMXPropertyId,
          type: ['basic', 'avm', 'listing', 'home'],
        });

      }

    });
    this.myHomeState.customEquity$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((data) => {

      this.purchaseValue = data?.customPurchaseValue || 0;
      this.customPurchasePrice = data?.customPurchaseValue || this.propertyData?.purchasePrice || 0
      this.appreciateRatio = this.propmixValue && this.purchaseValue
        ? ((this.propmixValue - this.purchaseValue) / this.purchaseValue) * 100
        : 0;
    });



    this.myHomeState.mortgageList$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((data) => {
      if (data) {
        // this.mortgageArray = [].concat(data);
        let loanAmount = 0;
        if (data && data.length) {
          data.map((element) => {
            if (element && element.principalBalance && isFinite(element.principalBalance)) {
              loanAmount = loanAmount + element.principalBalance;
            }
          });
        }
        this.loanBalance = JSON.parse(JSON.stringify(loanAmount));
        this.netEquity = (this.propmixValue || this.currentValue) - this.loanBalance;
        this.finalMortgaeList = data;
      }

    });

    this.myHomeState.activePropertyDetails$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((data) => {
      this.listingData = data?.listing
      if (data) {
        this.propertyData = this.transformProperty(data)
      }
      if (this.source) {
        this.propmixValue = this.propertyData?.propmixValue || 0;
        this.currentValue = this.propertyData?.currentValue || 0;
        this.netEquity = (this.propmixValue || this.currentValue) - this.loanBalance;
        this.getEquityAnalysisById(this.equityId);

      }

    });

    this.myHomeState.customMonthlyDataValue$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((data) => {
        this.customMonthlyCostData = data || null;
      });
  }



  saveEquity() {

    if (this.source == 'edit') {
      this.myHomeState.savedEquityData$
        .pipe(take(1))
        .subscribe((data) => {
          if (data) {
            const selectedEquity = data.find(item => item._id === this.equityId);
            this.existingEquityName = selectedEquity?.name
          }

        });
      const saveEquityData = {
        ...this.propertyData,
        ...(this.customMonthlyCostData || {}),
        mortgageHistory: this.finalMortgaeList
      };
      saveEquityData['name'] = this.existingEquityName;
      saveEquityData['customPurchasePrice'] = this.customPurchasePrice;
      saveEquityData['action'] = 'edit';
      saveEquityData['equityId'] = this.equityId
      if (saveEquityData) {
        this.myHomeService.saveEquityAnalysis(saveEquityData).subscribe((res) => { });
      }
    }
    else {
      const dialogRef = this.dialog.open(SaveEquityAnalysisDialogboxComponent, {
        width: '400px',
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(equityName => {
        if (equityName) {
          const saveEquityData = {
            ...this.propertyData,
            ...(this.customMonthlyCostData || {}),
            mortgageHistory: this.finalMortgaeList
          };
          saveEquityData['name'] = equityName;
          saveEquityData['customPurchasePrice'] = this.customPurchasePrice;
          if (this.source == 'edit') {
            saveEquityData['action'] = 'edit';
            saveEquityData['equityId'] = this.equityId
          }
          if (saveEquityData) {
            this.myHomeService.saveEquityAnalysis(saveEquityData).subscribe((res) => { });
          }
        }
      });
    }

  }
  equityAnalysis(params) {

    let equityParams = {
      pmxPropertyId: params?.PMXPropertyId
    }

    this.myHomeService.getEquityAnalysis(equityParams).subscribe((res) => {

      this.propmixValue = res?.data?.propmixValue || 0;
      this.currentValue = res?.data?.currentValue || 0;
      this.purchaseValue = res?.data?.purchasePrice || 0;
      this.appreciateRatio = this.propmixValue && this.purchaseValue
        ? ((this.propmixValue - this.purchaseValue) / this.purchaseValue) * 100
        : 0;
      this.formatMortgage = this.setInitialProjection(res?.data);
      this.myHomeState.mortgageListValue = this.formatMortgage.mortgageList
    });
  }

  getEquityAnalysisById(id) {
    this.myHomeService.getEquityAnalysisById({ equityId: id }).pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res && res?.data) {
        this.purchaseValue = res?.data?.customPurchasePrice ? res?.data?.customPurchasePrice : res?.data.purchasePrice || 0;
        this.appreciateRatio = this.propmixValue && this.purchaseValue
          ? ((this.propmixValue - this.purchaseValue) / this.purchaseValue) * 100
          : 0;
        this.myHomeState.mortgageListValue = res?.data?.mortgageHistory;
        this.myHomeState.customMonthlyDataOnLoad = res?.data
      }
    });

  }

  setInitialProjection(home) {
    if (home && home.mortgageHistory && home.mortgageHistory.length) {
      const mortgageList = home.mortgageHistory.map((mortgage) => {
        let loanComputation = this.loanService.computeTotalLoan(
          mortgage.principal,
          mortgage.interest / 100,
          mortgage.term,
          new Date(mortgage.startDate)
        );
        mortgage = { ...mortgage, ...loanComputation };
        mortgage.activeRefinance = this.loanService.computeBalanceLoan(
          loanComputation.principalBalance,
          mortgage.interest / 100,
          15 * 12
        );
        mortgage['temp_id'] = Date.now() + Math.floor(Math.random() * 1000);
        return mortgage;
      });
      home.mortgageList = mortgageList;
    }
    return home;

  }
  transformProperty(data: any) {
    if (!data) {
      return null;
    }

    const basic = data.basic ?? data;
    const listing = data.listing ?? {};
    const avmList = data.avmList ?? {}
    const homeValue = data.homeValue ?? {}
    const latitude = basic.Latitude ?? listing.Latitude ?? data.coordinate?.lat;
    const longitude = basic.Longitude ?? listing.Longitude ?? data.coordinate?.lng;


    const purchaseDate =
      basic.LastSaleContractDate ??
      basic.OwnedSince ??
      data.purchaseDate ??
      null;

    return {
      streetAddress:
        basic.StreetAddress ??
        listing.UnparsedAddress ??
        data.streetAddress ??
        null,

      fullAddress:
        basic.Address ??
        listing.Address ??
        data.fullAddress ??
        null,

      city: basic.City ?? listing.City ?? data.city ?? null,

      state:
        basic.StateOrProvince ??
        listing.StateOrProvince ??
        data.state ??
        null,

      zip:
        basic.PostalCode ??
        listing.PostalCode ??
        data.zip ??
        null,

      propertySubType:
        basic.PropertySubType ??
        listing.PropertySubType ??
        data.propertySubType ??
        null,

      bedCount:
        basic.BedroomsTotal ??
        data.bedCount ??
        null,

      bathCount:
        basic.BathroomsTotalInteger ??
        listing.BathroomsTotalInteger ??
        data.bathCount ??
        null,

      livingAreaSize:
        basic.LivingArea ??
        listing.LivingArea ??
        data.livingAreaSize ??
        null,

      lotSize:
        basic.LotSizeSquareFeet ??
        data.lotSize ??
        null,

      coordinate: {
        lat: latitude != null ? Number(latitude) : null,
        lng: longitude != null ? Number(longitude) : null
      },

      PMXPropertyId:
        basic.PMXPropertyId ??
        listing.PMXPropertyId ??
        data.PMXPropertyId ??
        null,

      id: data.id ?? null,

      streetName:
        basic.StreetName ??
        listing.StreetName ??
        data.streetName ??
        null,

      streetNumber:
        basic.StreetNumber ??
        listing.StreetNumber ??
        data.streetNumber ??
        null,

      propertyType:
        basic.PropertyType ??
        listing.PropertyType ??
        data.propertyType ??
        null,

      purchaseDate: purchaseDate
        ? new Date(purchaseDate).toISOString()
        : null,

      lstListingId:
        basic.Lst_ListingId ??
        listing.ListingId ??
        data.lstListingId ??
        null,

      currentValue: avmList?.[0]?.AVMValue ?? 0,
      propmixValue: homeValue ? homeValue.HomeValue : 0,
      purchasePrice: basic && basic.ClosePrice ? basic.ClosePrice : basic.Lst_ClosePrice || 0,
    };
  }

  ngOnDestroy() {

    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
    this.resetData();

  }

  resetData() {
    this.purchaseValue = 0;
    this.customPurchasePrice = 0;
    this.customMonthlyCostData = null;
    this.existingEquityName = null;
    this.mortgageArray = [];
    this.finalMortgaeList = [];
    this.loanBalance = 0;

    this.myHomeState.customEquityData = null;
    this.myHomeState.customMonthlyData = null;
    this.myHomeState.customMonthlyDataOnLoad = null;
    this.myHomeState.mortgageListValue = [];
  }
}
